import { useMemo } from "react";

import { useOpenMatches } from "@/queries/matches";
import { useNotificationAttention } from "@/hooks/useNotificationAttention";

export function useAccountAttention() {
  const notificationAttention = useNotificationAttention();
  const { data: matches = [], isLoading: matchesLoading } = useOpenMatches({
    staleTime: Infinity,
  });

  const outdatedProtocolCount = useMemo(() => {
    const items = Array.isArray(matches) ? matches : [];
    return items.filter((match) => {
      const lineupOutdated = match?.lineup_sync?.status === "outdated";
      const status = String(match?.status || "").toLowerCase();
      const actionable = status !== "confirmed";
      return lineupOutdated && actionable;
    }).length;
  }, [matches]);

  const needsProtocolAttention = outdatedProtocolCount > 0;
  const needsAccountAttention =
    notificationAttention.needsNotificationsAttention || needsProtocolAttention;

  return {
    ...notificationAttention,
    isLoading: notificationAttention.isLoading || matchesLoading,
    outdatedProtocolCount,
    needsProtocolAttention,
    needsAccountAttention,
  };
}
